import { Flex } from 'antd';

import { $$$ } from '@suntex.core/text';
import { asPath } from '@suntex.core/text/extensions';
import { isPlayerLoginType } from '@suntex.fim/auth';
import { useAuth } from '@suntex.fim/auth/react';
import { Button } from '@suntex.fim/ui';

import { usePlayerContext } from '../../context';
import { useModuleNavigation } from '../../navigation';

export interface GameActionsProps {
  href: string;
  label?: string;
}

export function GameActions({ href, label }: GameActionsProps) {
  const { isPreview } = usePlayerContext();
  const { login } = useAuth();
  const { navigateToModule } = useModuleNavigation();

  const showPreview = !!login && !isPlayerLoginType(login.loginType);
  const previewHref = $$$(href, asPath()).withParams({ preview: 'true' }).$$;

  return (
    <Flex gap={8} justify="center">
      {!isPreview && (
        <Button
          aria-label={label ? `Play ${label}` : undefined}
          onClick={() => navigateToModule(href)}
        >
          Play
        </Button>
      )}
      {showPreview && (
        <Button
          aria-label={label ? `Preview ${label}` : undefined}
          size="small"
          onClick={() => navigateToModule(previewHref)}
        >
          Preview
        </Button>
      )}
    </Flex>
  );
}
